
import React, { useEffect, useState } from 'react';
import { useAdminTheme } from '../context/AdminThemeContext';
import { Upload, Trash2, FileText, Loader2 } from 'lucide-react';
import Notification from '../../Component/Notification';
import { useAuth } from '../../context/AuthContext';

const AdminInterview: React.FC = () => {
  const { colors } = useAdminTheme();
  const { token } = useAuth();
  const [activeTab, setActiveTab] = useState<'upload' | 'list'>('list');
  const [files, setFiles] = useState<any[]>([]);
  const [uploading, setUploading] = useState(false);
  
  const [formData, setFormData] = useState({ title: '', subject: '' });
  const [file, setFile] = useState<File | null>(null);

  const [notify, setNotify] = useState<{ isOpen: boolean; message: string; type: 'success' | 'error' }>({
    isOpen: false, message: '', type: 'success'
  });

  useEffect(() => { fetchFiles(); }, []);

  const fetchFiles = async () => {
    try {
      // const res = await fetch('http://localhost:2025/api/interview-files');
      const res = await fetch('https://www.projectinfotech.in/api/interview-files');
      if (res.ok) setFiles(await res.json());
    } catch (err) { console.error(err); }
  };

  const handleUpload = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!file) return alert("Select a PDF");
    
    const data = new FormData();
    data.append('file', file);
    data.append('title', formData.title);
    data.append('subject', formData.subject);

    setUploading(true);
    try {
      // const res = await fetch('http://localhost:2025/api/interview-files/upload', { 
      const res = await fetch('https://www.projectinfotech.in/api/interview-files/upload', { 
          method: 'POST', 
          headers: { 'Authorization': `Bearer ${token}` },
          body: data 
      });

      if (res.ok) {
        setNotify({ isOpen: true, message: 'Uploaded successfully!', type: 'success' });
        setFormData({ title: '', subject: '' });
        setFile(null);
        fetchFiles();
        setActiveTab('list');
      } else {
        setNotify({ isOpen: true, message: 'Upload failed', type: 'error' });
      }
    } catch (err) {
        setNotify({ isOpen: true, message: 'Error', type: 'error' });
    } finally {
        setUploading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if(!window.confirm("Delete file?")) return;
    // await fetch(`http://localhost:2025/api/interview-files/${id}`, { 
    await fetch(`https://www.projectinfotech.in/api/interview-files/${id}`, { 
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    setFiles(files.filter(f => f.id !== id));
  };

  return (
    <div className="animate-fade-in-up">
      <Notification isOpen={notify.isOpen} message={notify.message} type={notify.type} onClose={() => setNotify({ ...notify, isOpen: false })} />
      
      <div className="flex justify-between items-center mb-6">
        <h2 className={`text-2xl font-bold ${colors.navbarText}`}>Interview Q&A Manager</h2>
        <div className="flex gap-2">
            <button onClick={() => setActiveTab('list')} className={`px-4 py-2 rounded-lg font-bold ${activeTab === 'list' ? colors.button3D + ' text-white' : 'bg-gray-100'}`}>List</button>
            <button onClick={() => setActiveTab('upload')} className={`px-4 py-2 rounded-lg font-bold ${activeTab === 'upload' ? colors.button3D + ' text-white' : 'bg-gray-100'}`}>Upload</button>
        </div>
      </div>

      <div className={`p-6 rounded-xl shadow-sm border ${colors.cardBg} ${colors.borderColor}`}>
        {activeTab === 'upload' ? (
            <form onSubmit={handleUpload} className="max-w-lg mx-auto space-y-4">
                <input type="text" placeholder="Title (e.g. Top 50 Java Questions)" required value={formData.title} onChange={e => setFormData({...formData, title: e.target.value})} className="w-full p-3 border rounded-lg" />
                <select required value={formData.subject} onChange={e => setFormData({...formData, subject: e.target.value})} className="w-full p-3 border rounded-lg">
                    <option value="">Select Subject</option>
                    <option value="Java">Java</option>
                    <option value="Python">Python</option>
                    <option value="MERN">MERN Stack</option>
                    <option value="HR">HR / General</option>
                </select>
                <input type="file" accept=".pdf" onChange={e => setFile(e.target.files ? e.target.files[0] : null)} className="w-full" required />
                <button type="submit" disabled={uploading} className={`w-full py-3 rounded-lg text-white font-bold ${colors.button3D}`}>
                    {uploading ? "Uploading..." : "Upload File"}
                </button>
            </form>
        ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {files.map(file => (
                    <div key={file.id} className="p-4 border rounded-xl flex justify-between items-center bg-white shadow-sm">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-blue-50 text-blue-600 rounded-lg"><FileText size={24}/></div>
                            <div>
                                <h4 className="font-bold text-gray-800">{file.title}</h4>
                                <span className="text-xs bg-gray-100 px-2 py-1 rounded">{file.subject}</span>
                            </div>
                        </div>
                        <button onClick={() => handleDelete(file.id)} className="text-red-500 hover:bg-red-50 p-2 rounded"><Trash2 size={18}/></button>
                    </div>
                ))}
            </div>
        )}
      </div>
    </div>
  );
};

export default AdminInterview;